import { COPY_CUSTOMER_EMAIL } from '../types'

export function doCopyCustomerEmail(email) {
  return {
    type: COPY_CUSTOMER_EMAIL,
    payload: { email },
  }
}
